// Login
export const RESET_VALUES = 'RESET_VALUES';

export const MSISDN_IN_HEADER = 'MSISDN_IN_HEADER';
export const ACTIVATION_STEP = 'ACTIVATION_STEP';


// WEBPACK FOOTER //
// ./src/actions/login-actions.js